import React from 'react'
import { Configure, connectHits } from 'react-instantsearch-dom'
import { ClearRefinementsButton } from '@mindfulchefuk/components/Search/Filters/ClearRefinementsButton'
import { SearchGrid } from '@mindfulchefuk/components/Search/SearchGrid'
import { SearchResult } from '@mindfulchefuk/components/Search/SearchResult'
import { Pagination } from '@mindfulchefuk/components/Recipes/Pagination'
import { Box, Flex } from '@mindfulchefuk/design-system/layout'
import { Text } from '@mindfulchefuk/design-system/Text'

type TSearchResultResponse = {
  objectID?: number | string
  title: string
  slug: string

  primary_image?: string
}

export const RecipeResults = connectHits<TSearchResultResponse>(({ hits }) => (
  <Box>
    {hits.length ? (
      <>
        <SearchGrid>
          {hits.map(
            ({ objectID, title, slug, primary_image: primaryImage }) => (
              <SearchResult
                key={objectID}
                primaryImage={primaryImage}
                title={title}
                slug={slug}
              />
            )
          )}
        </SearchGrid>
        <Configure hitsPerPage={9} />
        <Pagination />
      </>
    ) : (
      <Flex direction="column" justify="center" align="center" p={32}>
        <Text variant="body-md" mb={16} color="aubergine">
          Unfortunately we have no recipes matching your search criteria.
        </Text>
        <ClearRefinementsButton />
      </Flex>
    )}
  </Box>
))
